import { getDeviceId, getDeviceLabel, settings, displayPrefs, updateDisplayPrefs } from "../state/config.js";
import { currentUser, logout } from "../state/auth.js";
import { screen } from "../state/store.js";
import {
  localOnline,
  cloudOnline,
  cloudConfigured,
  cloudBaseUrl,
  kitchenOnline,
  lastError,
  pendingOrderIds,
} from "../state/sync.js";
import { canInstall, isStandalone, isIOS, promptInstall } from "../state/install.js";

// mehr als 4 Spalten bringen auf Handy-Displays nichts (Buttons zu schmal) → Deckel bei 4.
const COL_CHOICES = [2, 3, 4];
const SCALE_CHOICES: [string, number][] = [
  ["S", 0.9],
  ["M", 1.0],
  ["L", 1.2],
  ["XL", 1.4],
];

export function SettingsModal({ onClose }: { onClose: () => void }) {
  const prefs = displayPrefs.value;
  return (
    <div class="modal-backdrop" onClick={onClose}>
      <div class="modal" onClick={(e) => e.stopPropagation()}>
        <h2>Einstellungen</h2>

        <div class="logged-in">
          Angemeldet: <b>{currentUser.value?.name}</b>
          <button
            class="btn-secondary"
            onClick={() => {
              logout();
              onClose();
            }}
          >
            Abmelden
          </button>
        </div>

        {currentUser.value?.role === "admin" && (
          <div class="admin-link-row">
            {/* In-App-Verwaltung (Auswertung/Bestellungen/Bons/Verfügbarkeit/Personal/Tische) —
                ohne Account-Login, gegen den bereits gesyncten Event-Log + Geräte-Token. */}
            <button
              class="btn-primary"
              onClick={() => {
                screen.value = "admin";
                onClose();
              }}
            >
              🛠️ Verwaltung
            </button>
            {/* Erweiterte Verwaltung (voller Speisekarten-Editor, Geräte, Stationen) bleibt im
                Cloud-/Console-Admin. Vor Ort → lokale Konsole (/console, LAN-offen); sonst →
                Cloud-PHP-Admin dieser Veranstaltung (eigener Login). */}
            {(localOnline.value || cloudBaseUrl.value) && (
              <a
                class="btn-secondary"
                href={
                  localOnline.value
                    ? "/console"
                    : `${cloudBaseUrl.value}/veranstaltung.php?venue=${encodeURIComponent(settings.value.venueId)}`
                }
                {...(localOnline.value ? {} : { target: "_blank", rel: "noreferrer" })}
              >
                Erweitert (Speisekarte, Geräte)…
              </a>
            )}
          </div>
        )}

        <div class="display-prefs">
          <div class="pref-row">
            <span class="pref-label">Spalten</span>
            <div class="seg">
              {COL_CHOICES.map((n) => (
                <button
                  key={n}
                  class={`seg-btn ${prefs.cols === n ? "on" : ""}`}
                  onClick={() => updateDisplayPrefs({ cols: n })}
                >
                  {n}
                </button>
              ))}
            </div>
          </div>
          <div class="pref-row">
            <span class="pref-label">Schrift</span>
            <div class="seg">
              {SCALE_CHOICES.map(([label, val]) => (
                <button
                  key={label}
                  class={`seg-btn ${Math.abs(prefs.fontScale - val) < 0.01 ? "on" : ""}`}
                  onClick={() => updateDisplayPrefs({ fontScale: val })}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div class="conn-status">
          <div class={`conn-row ${localOnline.value ? "on" : "off"}`}>
            <span class="dot" /> Lokaler Server: {localOnline.value ? "verbunden" : "nicht verbunden"}
          </div>
          <div class={`conn-row ${cloudOnline.value ? "on" : "off"}`}>
            <span class="dot" /> Cloud:{" "}
            {cloudOnline.value
              ? cloudConfigured.value
                ? "verbunden"
                : "verbunden – nicht konfiguriert"
              : "nicht verbunden"}
          </div>
          {!localOnline.value && kitchenOnline.value !== null && (
            <div class={`conn-row ${kitchenOnline.value ? "on" : "off"}`}>
              <span class="dot" /> Küche:{" "}
              {kitchenOnline.value ? "verbunden (druckt)" : "offline – Bons werden NICHT gedruckt"}
            </div>
          )}
          {pendingOrderIds.value.size > 0 && (
            <div class="conn-row off">
              <span class="dot" /> {pendingOrderIds.value.size} Bestellung(en) noch nicht übermittelt
            </div>
          )}
          {lastError.value && (
            <div class="conn-error">Letzter Sync-Fehler: {lastError.value}</div>
          )}
        </div>

        <div class="install-row">
          {isStandalone.value ? (
            <span class="install-done">✓ Als App installiert</span>
          ) : canInstall.value ? (
            <button class="btn-primary" onClick={() => void promptInstall()}>
              📲 Als App installieren
            </button>
          ) : isIOS ? (
            <span class="install-hint">
              Installieren: In Safari <b>Teilen</b> ⎋ → <b>Zum Home-Bildschirm</b>.
            </span>
          ) : (
            <span class="install-hint">
              Installieren über das Browser-Menü (⋮) → <b>App installieren</b>.
            </span>
          )}
        </div>

        <div class="device-id">Gerät: {getDeviceLabel()}</div>
        <div class="device-id">Geräte-ID: {getDeviceId()}</div>
        <div class="device-id">Veranstaltung: {settings.value.venueId}</div>

        <div class="modal-foot">
          <button class="btn-primary" onClick={onClose}>
            Schließen
          </button>
        </div>
      </div>
    </div>
  );
}
